<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eXpfpo/tc-custom/9780718032777.jpg?1705029191166" alt="This image is the cover for the book Angel Answer Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Angel Answer Book
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Uncover the mystery of angels and their roles in our lives!</b></p><p>Angels have been present since the beginning of time, yet we’re filled with more intrigue and myth than with facts about these heavenly creatures. In this practical Q&amp;A format, bestselling author and pastor Robert J. Morgan uncovers the mystery of angels—in the teachings of the Bible, in their role in relation to Christ, how they impact Christian beliefs, and in personal accounts of our present-day lives. This is an up close and revealing look at what angels do for us as they carry out their purpose in God’s overall plan for His kingdom. </p><p>Trim size: 4.5 x 6.5</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert J. Morgan
      </h2>
      
      <p class="authorDescription body article"><P>Robert J. Morgan teaches the Bible each week on his podcast, The Robert J. Morgan Podcast, and through his speaking engagements and his books, including: <I>The Red Sea Rules, The Strength You Need, 100 Bible Verses That Made America, The 50 Final Events in World History, and Then Sings My Soul.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2907fe98